export const gtag = function () {
  if (window.gtag === undefined) {
    console.info('window.gtag is undefined.');

    return;
  }

  window.gtag.apply(undefined, arguments);
}
